import React from "react";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * EmployeeSidebar
 * Componente que renderiza a lista de Colaboradores no painel lateral do layout Master-Detail.
 */
const EmployeeSidebar = ({
    employees,
    roles,
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {

    // Auxiliar para obter o nome do cargo (role)
    const getRoleName = (employee) => {
        if (employee.role === 'admin') return 'Administrador';
        if (employee.role === 'owner') return 'Dono / Sócio';
        const roleObj = roles?.find(r => r.id === employee.role);
        // Fallback pro nome salvo caso os roles demorem ou sumam
        return roleObj ? roleObj.name : (employee.roleName || "Cargo Vazio");
    };

    // Função para renderizar cada item da lista
    const renderEmployeeItem = (employee, isActive) => (
        <div className="d-flex align-items-center w-100 overflow-hidden">
            <div className="avatar-xs flex-shrink-0 me-3 rounded-circle shadow-sm">
                {employee.photoUrl ? (
                    <img
                        src={employee.photoUrl}
                        alt={employee.fullName}
                        className="img-fluid rounded-circle w-100 h-100"
                        style={{ objectFit: 'cover' }}
                    />
                ) : (
                    <span className="avatar-title rounded-circle bg-light-soft text-primary font-size-18">
                        {employee.fullName ? employee.fullName.charAt(0).toUpperCase() : <i className="mdi mdi-account"></i>}
                    </span>
                )}
            </div>
            <div className="text-start flex-grow-1 overflow-hidden">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                        {employee.fullName}
                    </p>
                    {employee.status !== GLOBAL_STATUS.ACTIVE && (
                        <i className={`mdi ${employee.status === 'suspended' ? 'mdi-account-alert-outline text-warning' : 'mdi-eye-off-outline text-muted'}`} style={{ fontSize: '14px' }} title={employee.status === 'suspended' ? 'Suspenso' : 'Inativo'}></i>
                    )}
                </div>
                <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                    {getRoleName(employee)}
                </span>
            </div>
        </div>
    );

    return (
        <MasterSidebar
            title="Colaboradores"
            subtitle={`${employees?.length || 0} cadastrados`}
            items={employees}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar colaborador..."
            icon="mdi mdi-account-group-outline"
            renderItem={renderEmployeeItem}
            loadingMessage="Carregando colaboradores..."
        />
    );
};

EmployeeSidebar.propTypes = {
    employees: PropTypes.array.isRequired,
    roles: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default EmployeeSidebar;
